import Image from 'next/image';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { MediaType } from '@/utils/hooks/swr/useLibraryMedia/types/types';

// Component
import Icon from '@/components/base/Icon';

type MediaDocumentProps = {
    image: string;
};

function DocumentImagePreview({ image }: MediaDocumentProps) {
    if (image) {
        return (
            <Image
                alt=""
                src={image}
                width={600}
                height={600}
                className="h-full w-full rounded-lg object-cover"
            />
        );
    }

    return (
        <div className="flex h-96 w-full items-center justify-center">
            <Icon icon="content" className="text-8xl text-icoGray-500 dark:text-icoDarkMode-wolf" />
        </div>
    );
}

function ImageWrapper({ children }: React.ComponentPropsWithoutRef<'div'>) {
    return (
        <div className="flex min-h-full min-w-[85%] items-center justify-center overflow-hidden rounded-lg bg-icoGray-300 dark:bg-icoDarkMode-anthracite">
            {children}
        </div>
    );
}

type DocumentPreviewProps = {
    document: Extract<MediaType, { type: 'document' }>;
};
export function DocumentPreview({ document }: DocumentPreviewProps) {
    const { t } = useTranslation('scheduler');

    const nbPages = document?.file_info?.nb_pages ?? null;

    return (
        <div className="w-full space-y-5 overflow-hidden bg-icoGray-100 p-3 dark:bg-icoDarkMode-deepBlack">
            {nbPages ? (
                <div className="flex items-center text-sm">
                    <span className="font-GMedium">
                        {t('document.nb_pages', { count: nbPages })}
                    </span>
                </div>
            ) : null}
            <div
                className={clsx('flex w-full items-center gap-3', {
                    'justify-center': !document?.document_page2
                })}>
                <ImageWrapper>
                    <DocumentImagePreview image={document?.document_page1} />
                </ImageWrapper>
                {document?.document_page2 ? (
                    <ImageWrapper>
                        <DocumentImagePreview image={document.document_page2} />
                    </ImageWrapper>
                ) : null}
            </div>
        </div>
    );
}
